import React, { Component } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import moment from 'moment';

const PROCTORING_TYPES = {
    1: "Voice Detected",
    2: "Face Detection",
    3: "Multiple Faces",
    4: "Tab Switch",
    5: "Devtools Open",
    6: "Copy-Paste",
    7: "Exit Fullscreen",
    8: "Multiple Screens",
    9: "Camera Denied",
    10: "Microphone Denied"
};

class SingleStudentProctoringModal extends Component {
    render() {
        const { show, onHide, proctoringData } = this.props;
        console.log(proctoringData, "proctoringData")
        return (
            <Modal show={show} onHide={onHide} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Student Proctoring Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {proctoringData && proctoringData.length > 0 ? (
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Violation Type</th>
                                    <th>Time</th>
                                    {/* <th>Status</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {proctoringData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{PROCTORING_TYPES[item.proctoring_type_id] || `Type ${item.proctoring_type_id}`}</td>
                                        <td>{item.inserted_at ? moment(item.inserted_at).format("YYYY-MM-DD | hh:mm A") : "N/A"}</td>
                                        {/* <td>{item.estatus === 1 ? <span className="text-success">Active</span> : <span className="text-danger">Inactive</span>}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <div className="text-center p-4">
                            <h5>No proctoring data available for this student.</h5>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SingleStudentProctoringModal;
